import { defineAsyncComponent } from 'vue'
export default {
  area: defineAsyncComponent(() => import("/tmp/tmphhf7t3xx/layouts/area.vue").then(m => m.default || m)),
  point: defineAsyncComponent(() => import("/tmp/tmphhf7t3xx/layouts/point.vue").then(m => m.default || m)),
  pref: defineAsyncComponent(() => import("/tmp/tmphhf7t3xx/layouts/pref.vue").then(m => m.default || m)),
  ranking: defineAsyncComponent(() => import("/tmp/tmphhf7t3xx/layouts/ranking.vue").then(m => m.default || m)),
  top: defineAsyncComponent(() => import("/tmp/tmphhf7t3xx/layouts/top.vue").then(m => m.default || m))
}